<div class="modal-body">
  <div class="row">
    <div class="col-md-12 col-sm-12 mb-3">
      <h2 class="modal-title">
        {{ "handelsangabenZu" | translate }}
        {{ erwerberVeraeusserer.beteiligung | translate }}
        <cap-kompakt-persongb [auskunftsperre]="auskunftsperre" [enableNavigation]="false" [item]="gbPerson"></cap-kompakt-persongb>
      </h2>
    </div>

    <div class="col-md-6 col-sm-12">
      <cap-kopfdatenelement label="Grundstueck">
        {{ erwerberVeraeusserer.eigentumAnteil?.belastetesGrundstueck | kompaktGrundstueck: language }}
      </cap-kopfdatenelement>
    </div>
    <div class="col-md-6 col-sm-12">
      <cap-kopfdatenelement label="Eigentumsform">
        {{ erwerberVeraeusserer.eigentumAnteil?.versions[0].eigentumsform | translate }}
      </cap-kopfdatenelement>
    </div>
  </div>

  <div class="title-divider mt-1 row rubrik-divider mb-1">
    <h3 class="mb-1 mt-0 rubrik-title">{{ "Handelsangaben" | translate }}</h3>
  </div>

  <div class="row">
    <div class="col-md-6 col-sm-12">
      <cap-kopfdatenelement label="Preis">
        {{ handelsangaben.preis | betrag }}
      </cap-kopfdatenelement>
      <cap-kopfdatenelement label="Flaeche">
        @if (handelsangaben.flaecheQuadratmeter) {
          <span> {{ handelsangaben.flaecheQuadratmeter | decimalHochkomma }}&nbsp;m² </span>
        }
      </cap-kopfdatenelement>
    </div>
    <div class="col-md-6 col-sm-12">
      <cap-kopfdatenelement label="Wertquote">
        @if (handelsangaben.quote) {
          <span> {{ handelsangaben.quote.zaehler }}/{{ handelsangaben.quote.nenner }} </span>
        }
      </cap-kopfdatenelement>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <cap-kopfdatenelement bodyClass="col-lg-10" label="Bemerkung" labelClass="col-md-2">
        <div class="align-read-more">
          <cap-read-more [limit]="160" [text]="handelsangaben.bemerkungen"></cap-read-more>
        </div>
      </cap-kopfdatenelement>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button (click)="activeModal.close(false)" class="btn btn-primary" type="button">
    {{ "Schliessen" | translate }}
  </button>
</div>
